import Accordion, { AccordionProps } from '@jbhi-fi/lanyard-ui/components/Accordion';
import React from 'react';
import { styles } from './ContentAccordion.css';

export const ContentAccordion = (props: AccordionProps) => {
  return (
    <Accordion
      {...props}
      accordionHeaderClassname={styles.contentAccordionHeader}
      accordionItemClassname={styles.accordionItems}
      accordionContentClassname={styles.accordionContent}
    />
  );
};
